import { render, staticRenderFns } from "./extra-category-slider.vue?vue&type=template&id=23b32b24&scoped=true&lang=pug&"
import script from "./extra-category-slider.vue?vue&type=script&lang=js&"
export * from "./extra-category-slider.vue?vue&type=script&lang=js&"
import style0 from "./extra-category-slider.vue?vue&type=style&index=0&id=23b32b24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b32b24",
  null
  
)

export default component.exports